/**
 * Prev/next arrow controls for the compact "You may also like" horizontal
 * carousel on the Autodoc product template. Swiping/scrolling works
 * natively via CSS scroll-snap; this just adds click-to-advance on desktop.
 */
document.querySelectorAll('[data-related-track]').forEach((track) => {
  const stage = track.closest('.autodoc-related__stage');
  if (!stage) return;

  const prevBtn = stage.querySelector('[data-related-prev]');
  const nextBtn = stage.querySelector('[data-related-next]');
  const items = Array.from(track.children);

  const itemWidth = () => (items[0] ? items[0].getBoundingClientRect().width + 12 : track.clientWidth);

  const updateArrows = () => {
    const maxScroll = track.scrollWidth - track.clientWidth - 1;
    if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -itemWidth() * 2, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: itemWidth() * 2, behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();
});
